export enum ValueType {
  FormPropertyValue = "FormPropertyValue",
  FormPropertyProjectIntakeStatusValue = "FormPropertyProjectIntakeStatusValue",
  FormPropertyUserValue = "FormPropertyUserValue",
  FormPropertyLocationValue = "FormPropertyLocationValue",
}
